export const requests = {
  page: {
    searchPlaceholder: 'Search',
    newRequestLabel: 'New Request',
    detailLabel: 'Detail',
    noRequestsTitle: 'No Requests',
    noRequestsDescription: 'There are no requests registered in the database '
  },
  columns: {
    name: 'Name',
    requestSent: 'Request Sent',
    requestGrantTime: 'Request Grant Time',
    truentityId: 'Truentity ID',
    purpose: 'Purpose',
    status: 'Status',
    details: 'Details'
  },
  createRequestDialog: {
    title: 'Patient Medication Request Info',
    successMessage: 'Request has been sent to patient.'
  }
} as const;
